// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.award-container {
  padding: 5% 10%;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: left;
}
.award-container svg {
  color: white;
}

.award {
  margin-top: 10px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.award-content {
  width: 40%;
  flex-direction: row;
  display: flex;
}

.zoom {
  border-radius: 5px;
  transition: transform 0.2s;
  margin: 0 auto;
}

.zoom:hover {
  transform: scale(2);
}

.media {
  width: 60%;
  height: 168px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

@media screen and (max-width: 768px) {
  .award {
    flex-direction: column;
  }
  .award-content {
    width: 100%;
  }
  .media {
    width: 100%;
    height: 180px;
  }
  .zoom {
    width: 100%;
  }
  .hide-on-mobile {
    display: none;
  }
}
@media screen and (max-width: 567px) {
  .skills {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Awards.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AACJ;AAAI;EACI,YAAA;AAER;;AAEA;EACI,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AACA;EACI,UAAA;EACA,mBAAA;EACA,aAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,0BAAA;EACA,cAAA;AAGJ;;AAAA;EACI,mBAAA;AAGJ;;AADA;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAIJ;;AADI;EACI;IACI,sBAAA;EAIV;EAFM;IACI,WAAA;EAIV;EAFM;IACI,WAAA;IACA,aAAA;EAIV;EAFM;IACI,WAAA;EAIV;EAFD;IACI,aAAA;EAIH;AACF;AADI;EACI;IACI,eAAA;EAGV;AACF","sourcesContent":[".award-container {\n    padding: 5% 10%;\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    justify-content: left;\n    svg {\n        color: white;\n    }\n}\n\n.award{\n    margin-top: 10px;\n    justify-content:space-between;\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n.award-content{\n    width: 40%;\n    flex-direction: row;\n    display: flex;\n}\n.zoom {\n    border-radius: 5px;\n    transition: transform .2s;\n    margin: 0 auto;\n}\n  \n.zoom:hover {\n    transform: scale(2);\n}\n.media {\n    width: 60%;\n    height: 168px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n}\n@media screen {\n    @media (max-width: 768px) {\n        .award {\n            flex-direction: column;\n        }\n        .award-content{\n            width: 100%;\n        }\n        .media{\n            width: 100%;\n            height: 180px;\n        }\n        .zoom{\n            width: 100%;\n    \t}\n\t.hide-on-mobile{\n\t    display: none;\n\t}\n    }\n\n    @media (max-width: 567px) {\n        .skills {\n            font-size: 12px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
